module.exports = __webpack_public_path__ + "img/2.9225e47a.png";